function Header() {
    return ( 
        <header className=' header tile'>
            <h1 className='header__title'>ШАУРМАЧО</h1>
        </header> 
    );
}

export default Header;